import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'PanoramaFishEyeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PanoramaFishEyeSharp.js
// module id = 5190
// module chunks = 2